<script>
    import IconFilter from '@/components/icon/IconFilter.vue';
    import constants from '@/constants';

    export default {
        computed: {
            constants() {return constants}
        },
        components: {
            ButtonIcon: IconFilter,
        }
    }
</script>


<template>
    <router-link 
        class="left_button_main_container"
        :to="{name: constants.ROUTER_NAME.FILTEREDIT}"    
    >
        <div class="left_button_icon_container">
            <ButtonIcon 
                iconWidth = "16px"
                iconHeight = "16px"
            />
        </div>
        <div class="left_button_label_container">
            <label class="cursor_pointer">Filter</label>
        </div>
    </router-link>
</template>